import { render, staticRenderFns } from "./ScrapAuthorizations.vue?vue&type=template&id=8d6f46ba"
import script from "./ScrapAuthorizations.vue?vue&type=script&lang=js"
export * from "./ScrapAuthorizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports